module.exports = __webpack_public_path__ + "media/images/favicons/android-chrome-128x128-bcc7ccbb4a52c98a22cf6b84c7c79bd9.png";